import { TsDOM as q} from '@/scripts/core/TsDOM'
import { DeferredMedia } from '@/scripts/theme/deferred-media'
import { DetailsDisclosure } from '@/scripts/theme/details-disclosure'
import { SliderComponent } from '@/scripts/theme/slider-component'
import { SlideshowComponent } from '@/scripts/theme/slideshow-component'
import { StickyHeader } from '@/scripts/theme/sticky-header'
import { UcoastVideo } from '@/scripts/core/ucoast-video';
import { ProductSlider } from '@/scripts/theme/product-slider'
import { MultiProductSlider } from '@/scripts/theme/multi-product-slider'
import { WaitlistForm } from '@/scripts/theme/waitlist-form'
import { KlaviyoForm } from '@/scripts/theme/klaviyo-form'
import { KlaviyoFormTrigger } from '@/scripts/theme/klaviyo-form-trigger'
import { WelcomePopup } from '@/scripts/theme/welcome-popup'
import { EmblaSlider } from '@/scripts/theme/embla'
import { LobbyRadio } from '@/scripts/theme/lobby-radio'
import { NyTimer } from '@/scripts/theme/ny-timer'
import { QuickAddForm } from '@/scripts/theme/quick-add-form'
import { QuickAddPopup } from '@/scripts/theme/quick-add-popup'
import { QuickAddToggle } from '@/scripts/theme/quick-add-popup'
import { BundlePackQuickAddTrigger } from '@/scripts/theme/quick-add-popup'
import { QuickAddPopupClose } from '@/scripts/theme/quick-add-popup'
import { CardSwatch } from '@/scripts/theme/card-swatch'
import { StickyButton } from '@/scripts/theme/sticky-button'
import { StickyList } from '@/scripts/theme/sticky-list'
import { TabsList } from '@/scripts/theme/tabs-list'
import { CustomAccordion } from '@/scripts/theme/custom-accordion'
import { initializePersonalizationBadgeTriggers } from '@/scripts/theme/personalization-badge'

q.safeDefineElement(UcoastVideo)
q.safeDefineElement(DeferredMedia)
q.safeDefineElement(SliderComponent)
q.safeDefineElement(SlideshowComponent)
q.safeDefineElement(StickyHeader)
q.safeDefineElement(DetailsDisclosure)
q.safeDefineElement(ProductSlider)
q.safeDefineElement(MultiProductSlider)
q.safeDefineElement(KlaviyoForm)
q.safeDefineElement(KlaviyoFormTrigger)
q.safeDefineElement(WelcomePopup)
q.safeDefineElement(WaitlistForm)
q.safeDefineElement(EmblaSlider)
q.safeDefineElement(LobbyRadio)
q.safeDefineElement(NyTimer)
q.safeDefineElement(QuickAddForm)
q.safeDefineElement(QuickAddPopup)
q.safeDefineElement(QuickAddToggle)
q.safeDefineElement(BundlePackQuickAddTrigger)
q.safeDefineElement(QuickAddPopupClose)
q.safeDefineElement(CardSwatch)
q.safeDefineElement(StickyButton)
q.safeDefineElement(StickyList)
q.safeDefineElement(TabsList)
q.safeDefineElement(CustomAccordion)

initializePersonalizationBadgeTriggers()
